import { DeletePreset } from '@/components/Generator/DeletePreset/DeletePreset'
import { DeleteProject } from '@/components/Generator/DeleteProject/DeleteProject'
import { DeleteTone } from '@/components/Generator/DeleteTone/DeleteTone'
import { GeneratorForm } from '@/components/Generator/GeneratorForm/GeneratorForm'
import { PostForm } from '@/components/Generator/PostForm/PostForm'
import { PresetForm } from '@/components/Generator/PresetForm/PresetForm'
import { ProjectForm } from '@/components/Generator/ProjectForm/ProjectForm'
import { ToneForm } from '@/components/Generator/ToneForm/ToneForm'
import { Loader } from '@/components/Loader/Loader'
import { Message } from '@/components/Message/Message'
import { Popup } from '@/components/Popup/Popup'
import { GeneratorFormContext, useGeneratorForm } from '@/hooks/useGeneratorForm'
import { useProjectsState } from '@/state/projects'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'

enum View {
  CreatePreset,
  EditPreset,
  DeletePreset,
  CreateTone,
  EditTone,
  DeleteTone,
  Generator,
  EditProject,
  CreateProject,
  DeleteProject,
  Post,
}

export const GeneratorPopup: FunctionalComponent<{
  onClose: () => void
}> = props => {
  const form = useGeneratorForm()
  const [view, setView] = useState(View.Generator)

  const empty = useProjectsState(s => s.empty)
  const projectsList = useProjectsState(s => s.list)
  const loading = useProjectsState(s => s.loading)

  return (
    <GeneratorFormContext.Provider value={form}>
      <Popup
        width={600}
        onClose={props.onClose}
      >
        {projectsList.length === 0 && loading
          ? (
            <Message>
              Loading <Loader />
            </Message>
          )
          : projectsList.length === 0 && empty
          ? (
            <ProjectForm
              type='create'
              onSuccess={() => {
                setView(View.Generator)
              }}
            />
          )
          : view === View.Generator
          ? (
            <GeneratorForm
              onClose={props.onClose}
              onAddPreset={() => {
                setView(View.CreatePreset)
              }}
              onEditPreset={() => {
                setView(View.EditPreset)
              }}
              onAddTone={() => {
                setView(View.CreateTone)
              }}
              onEditTone={() => {
                setView(View.EditTone)
              }}
              onAddProject={() => {
                setView(View.CreateProject)
              }}
              onEditProject={() => {
                setView(View.EditProject)
              }}
              onSuccess={() => {
                setView(View.Post)
              }}
            />
          )
          : (view === View.CreateProject || view === View.EditProject)
          ? (
            <ProjectForm
              type={view === View.CreateProject ? 'create' : 'edit'}
              onSuccess={() => {
                setView(View.Generator)
              }}
              onCancel={() => {
                setView(View.Generator)
              }}
              onDelete={() => {
                setView(View.DeleteProject)
              }}
            />
          )
          : view === View.Post
          ? <PostForm />
          : view === View.DeleteProject
          ? (
            <DeleteProject
              onSuccess={() => {
                setView(View.Generator)
              }}
              onCancel={() => {
                setView(View.EditProject)
              }}
            />
          )
          : (view === View.CreateTone || view === View.EditTone)
          ? (
            <ToneForm
              type={view === View.CreateTone ? 'create' : 'edit'}
              onSuccess={() => {
                setView(View.Generator)
              }}
              onCancel={() => {
                setView(View.Generator)
              }}
              onDelete={() => {
                setView(View.DeleteTone)
              }}
            />
          )
          : (view === View.CreatePreset || view === View.EditPreset)
          ? (
            <PresetForm
              type={view === View.CreatePreset ? 'create' : 'edit'}
              onSuccess={() => {
                setView(View.Generator)
              }}
              onCancel={() => {
                setView(View.Generator)
              }}
              onDelete={() => {
                setView(View.DeletePreset)
              }}
            />
          )
          : view === View.DeleteTone
          ? (
            <DeleteTone
              onSuccess={() => {
                setView(View.Generator)
              }}
              onCancel={() => {
                setView(View.EditTone)
              }}
            />
          )
          : view === View.DeletePreset
          ? (
            <DeletePreset
              onSuccess={() => {
                setView(View.Generator)
              }}
              onCancel={() => {
                setView(View.EditPreset)
              }}
            />
          )
          : (
            <Message>
              Loading <Loader />
            </Message>
          )}
      </Popup>
    </GeneratorFormContext.Provider>
  )
}
